import { render, staticRenderFns } from "./certifyStadard.vue?vue&type=template&id=4a172af1"
import script from "./certifyStadard.vue?vue&type=script&lang=js"
export * from "./certifyStadard.vue?vue&type=script&lang=js"
import style0 from "./certifyStadard.vue?vue&type=style&index=0&id=4a172af1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports